/**
 * Constants for device linking functionality
 */

export const DEVICE_LINKING = {
  /** Maximum number of devices that can be linked */
  MAX_DEVICES: 2,

  /** Link code expiry time in minutes */
  CODE_EXPIRY_MINUTES: 10,

  /** Link code length */
  CODE_LENGTH: 6,

  /** Copy feedback timeout in milliseconds */
  COPY_FEEDBACK_TIMEOUT: 2000,
};
